import React from "react";

const Loading = () => {
  return (
    <div className="flex items-center justify-center w-full h-[50vh]">
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-4 border-blue-500 rounded-full border-t-transparent animate-spin" />
        <span className="text-sm font-medium text-white/50 animate-pulse">
          Loading...
        </span>
      </div>
    </div>
  );
};

export default Loading;
